export default __webpack_public_path__ + "static/media/office-edit4.8f155693.png";